module.exports = __webpack_public_path__ + "assets_1789457014240/img/pic.cd38b695.png";